import { IAtendimentoFechado } from "../../../Interfaces/HelpDesk/Dashboard/DashboardInterfaces";
import { IEquipe } from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { GetDashboardInfoService } from "../../../Services/HelpDesk/Dashboard/DashboardServices";
import {
    count,
    groupBy,
    ITimeSettings,
    sliceByTime,
} from "../../../Tools/ProcessingTools";
import { Controller } from "../../Controller";

export async function GetDashboardInfoController() {
    return Controller(GetDashboardInfoService());
}

export function GetAtendimentosPorAtendente(
    atendimentos: Array<IAtendimentoFechado>
) {
    const mapAtendentes = groupBy(atendimentos, (e) => e.DS_NOME);
    const nomes = Array.from(mapAtendentes.keys());
    const dados = Array.from(mapAtendentes.values());

    return {
        nomes,
        dados: count(dados),
    };
}

export function GetAtendimentosPorPeriodo(
    atendimentos: Array<IAtendimentoFechado>,
    timeSettings: ITimeSettings
) {
    const timeSlicedData = sliceByTime(
        atendimentos,
        (e) => e.DT_FIM_CHAT,
        timeSettings
    );

    return {
        dados: count(timeSlicedData.dados),
        datas: timeSlicedData.datas.map(
            (data) => Math.floor((data.fim + data.inicio) / 2),
            []
        ),
    };
}

export function GetAtendimentosPorEquipePeriodo(
    atendimentos: Array<IAtendimentoFechado>,
    equipes: Array<IEquipe>,
    timeSettings: ITimeSettings
) {
    const mapEquipes = groupBy(atendimentos, (e) => e.DS_EQUIPE_HELP_DESK);
    const todosAtendimentosPorEquipe = Array.from(mapEquipes.entries());

    const datas = new Set<number>();
    const atendimentosPorEquipePorPeriodo = todosAtendimentosPorEquipe.reduce(
        (totalData, atendimentosDaEquipe) => {
            const atendimentosPorPeriodo = GetAtendimentosPorPeriodo(
                atendimentosDaEquipe[1],
                timeSettings
            );
            atendimentosPorPeriodo.datas.forEach((data) => datas.add(data));
            if (atendimentosDaEquipe[0])
                totalData.push({
                    data: atendimentosPorPeriodo.dados,
                    name: atendimentosDaEquipe[0],
                });
            return totalData;
        },
        [] as any
    );

    return {
        datas: Array.from(datas),
        dados: atendimentosPorEquipePorPeriodo,
    };
}

export function GetTempoMedioPorAtendente(
    atendimentos: Array<IAtendimentoFechado>
) {
    const mapAtendentes = groupBy(atendimentos, (e) => e.DS_NOME);
    const nomes = Array.from(mapAtendentes.keys());
    const atendimentosPorAtendente = Array.from(mapAtendentes.values());

    const dados = atendimentosPorAtendente.map((atendimentosDoAtendente) =>
        Math.floor(
            atendimentosDoAtendente.reduce(
                (sum, atendimento) =>
                    sum +
                    (new Date(atendimento.DT_FIM_CHAT).getTime() -
                        new Date(atendimento.DT_INICIO_CHAT).getTime()) /
                        (60 * 60 * 1000),
                0
            ) / atendimentosDoAtendente.length
        )
    );

    return {
        nomes,
        dados,
    };
}
